import styled from 'styled-components'

export const Footer = styled.footer`
     display: flex;
     justify-content: center;
     align-items: center;
     width: 100%;
     height: 40px;
     background-color: #0098AE;
`